import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ContractorsSchema from 'schemas/contractors.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import { addContractor, updateContractor } from 'utils/ContractorsUtils';
import {useFormContext} from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';
import ODataUtil from 'utils/ODataUtil';

const AddContractors = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    defaultValues = ODataUtil.unCoupleExpandsFromDefaults(defaultValues);

    const { selectedProject, selectedProjectData } = useAppContext();

    const formContext = useFormContext();

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ContractorsSchema);
    })

    if (CRUDType === "INSERT") defaultValues['IsActive'] = true && disabledProperties.push('IsActive');

    // contact specific CRUD functions
    const onSubmit = async (values) => {
        let result;
        if (CRUDType === "INSERT") {
            result = await addContractor(selectedProject, values);
            setTimeout(callback, 1000);
        } else if (CRUDType === "UPDATE") {
            result = await updateContractor(defaultValues.ContractorProjectId, values, defaultValues);
            setTimeout(callback, 1000);
        };

        return result;
    };
    /* 
    on rare occasions, this component may be reached before the full AppContext is done initializing.
    so this form only renders when there is data in selectedProjectData 
    */
    return selectedProjectData && formContext.ready ? 
    withExtension(DynamicForm, { schema: ContractorsSchema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions }) :
    <SkeletonForm />

}



AddContractors.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

AddContractors.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}




export default AddContractors
